import { z } from 'zod'

export const schemaRegisterProduct = z.object({
  category: z.object({
    codigo_grupo: z.string().nonempty('Campo obrigatório'),
    descricao_categoria: z.string().nonempty('Campo obrigatório'),
  }),
  name: z.string().max(39, 'O nome deve ter no máximo 39 caracteres').nonempty('Campo obrigatório'),
  ncm: z
    .string()
    .nonempty('Campo obrigatório')
    .min(5, 'O NCM deve no mínimo 5 dígitos')
    .max(8, 'O NCM deve no máximo 8 dígitos')
    .transform((value) => String(value)),

  cest: z
    .string()
    .optional()
    .transform((value) => String(value)),

  fornecedor: z.string().nonempty('Campo obrigatório'),
  corproduto: z.object({
    nome_cor: z.string().nonempty('Campo obrigatório'),
    id_cor: z.string().nonempty('Campo obrigatório'),
  }),
  referenciafornecedor: z
    .string()
    .nonempty('Campo obrigatório')
    .transform((value) => String(value)),

  bloqueia_fornecedor: z.string().nonempty('Campo obrigatório'),
  descricao_caracteristica: z.string().nonempty('Campo obrigatório').min(120, 'A descrição deve ter no mínimo 120 caracteres'),
})
